import BaseRepository from 'Domain/Repositories/BaseRepository/BaseRepository';
import { EventCategory }   from 'Domain/Models';

const config = {
    model: EventCategory,
    baseRoute: '/admin/event-category',
    singular: 'eventCategory',
    plural: 'eventCategories',
}

class EventCategoryRepository extends BaseRepository<EventCategory, typeof config.singular, typeof config.plural> {

}

export default new EventCategoryRepository(config);
